<template>
  <div class="allocate_quota_box">
    <!-- form居中显示 -->
    <el-form :model="form" :rules="rules" ref="formRef" label-width="80px">
      <el-form-item label="额度(元)" prop="limitCount">
        <el-input
          v-model="form.limitCount"
          placeholder="请输入分配额度"
        ></el-input>
      </el-form-item>
      <!-- 账期 -->
      <el-form-item label="账期(天)" prop="cycle">
        <el-input v-model="form.cycle" placeholder="请输入账期"></el-input>
      </el-form-item>
    </el-form>
    <!-- button居中 -->
    <div style="text-align: center;">
      <el-button style="width:200px;" type="primary" @click="submitForm"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import { addorupdate, getusersafe } from "@/api/shipment";
export default {
  name: "allocateQuota",
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        limitCount: "",
        cycle: ""
      },
      rules: {
        limitCount: [
          { required: true, message: "请输入分配额度", trigger: "blur" }
        ],
        cycle: [{ required: true, message: "请输入账期", trigger: "blur" }]
      }
    };
  },

  mounted() {
    this.getusersafe();
  },

  methods: {
    getusersafe() {
      getusersafe({
        partyCode: this.info.partyCode,
        userType: 0
      }).then(res => {
        console.log("获取额度配置", res);
        if (res.status == 0) {
          this.form.limitCount = res.data.limitCount;
          this.form.cycle = res.data.cycle;
        }
      });
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          console.log("表单校验通过");
          this.$confirm("确认提交吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            if (!this.form.cycle) {
              this.$message({
                message: "请输入账期",
                type: "warning"
              });
              return;
            }
            if (!this.form.limitCount) {
              this.$message({
                message: "请输入分配额度",
                type: "warning"
              });
              return;
            }
            let params = {
              cycle: this.form.cycle,
              partyCode: this.info.partyCode,
              userType: 0,
              cycleUnit: 0,
              limitCount: this.form.limitCount
            };
            addorupdate(params).then(res => {
              console.log("分配额度", res);
              if (res.status == 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });

                this.$emit("cancelModel");
              }
            });
          });
        } else {
          console.log("表单校验不通过");
        }
      });
    }
  }
};
</script>
<style scoped>
.allocate_quota_box {
  padding-top: 40px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
